import { createCallbackRegistry } from "../../utils/callbacks/customCallbackUtils";

export const createCallbackSlice = (set, get) => ({
  // Custom callback system state
  callbackRegistry: createCallbackRegistry(),

  // Custom callback system setters
  setCallbackRegistry: (registry) => set({ callbackRegistry: registry }),
  registerCallback: (name, callback) => {
    const { callbackRegistry } = get();
    callbackRegistry.register(name, callback);
  },
  unregisterCallback: (name) => {
    const { callbackRegistry } = get();
    callbackRegistry.unregister(name);
  },
  triggerCallback: async (name, data, context) => {
    const { callbackRegistry } = get();
    return await callbackRegistry.trigger(name, data, context);
  },
});
